import BG1 from '../assets/bgThemes/t-1.mp3';
import BG2 from '../assets/bgThemes/t-2.mp3';
import BG3 from '../assets/bgThemes/t-3.mp3';


// All backgound songs can be added/revmoved from here.
const allThemes = ["NoTheme" , BG1 , BG2 , BG3];


  export default allThemes;